import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import Button from './Button';
import Wizard from './Wizard';
const StartNowBanner = () => {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  // Optional: Hide banner after scrolling past a certain point
  useEffect(() => {
    const handleScroll = () => {
      // You can adjust this value based on when you want the banner to hide
      if (window.scrollY > 300) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed top-16 left-0 right-0 z-40 flex justify-center px-4" data-id="element-2195">
      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg shadow-lg py-2 px-4 flex items-center justify-between max-w-4xl w-full border border-indigo-500" data-id="element-2196">
        <div className="text-sm md:text-base font-medium" data-id="element-2197">
          Ready to transform your retail experience with AI?
        </div>
        <Button variant="primary" size="sm" className="bg-white text-indigo-700 hover:bg-indigo-50 whitespace-nowrap ml-4" onClick={() => setIsWizardOpen(true)} data-id="element-2198">
          Start Now <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-2199" />
        </Button>
      </div>
      <Wizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-2200" />
    </div>;
};
export default StartNowBanner;